import Hook from "../../utils/hook"
import { scrollIntoView } from "../../utils/scroll"

export const RegionPage = Hook(`RegionPage`, {
  refs: [`map`],
  targets: [`categoryButton`],
  actions: [
    {
      name: `categoryButtonClick`,
      targets: `categoryButton`,
      type: `click`,
    },
  ],

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.mapRef && window.location.hash == `#${this.mapRef.el.id}`)
          this.enterMapFullscreen()
        break
      }

      case `setQuery`: {
        this.mapQueryWasSet(message.data)
        break
      }
    }
  },

  enterMapFullscreen() {
    return new Promise((resolve) => {
      if (!this.mapRef) return

      scrollIntoView(this.mapRef.el, { block: `center` }).then(() => {
        if (this.mapRef) this.mapRef.setFullscreen(true).then(resolve)
      })
    })
  },

  categoryButtonClickAction(e) {
    const { categoryId } = e.currentTarget.dataset
    if (!this.mapRef || !categoryId) return
    e.preventDefault()
    e.stopImmediatePropagation()

    window.history.replaceState(null, null, `#${this.mapRef.el.id}`)

    this.enterMapFullscreen().then(() => {
      if (this.mapRef) this.mapRef.setQueryWithDefault(`category=${categoryId}`)
    })
  },

  mapQueryWasSet(query) {
    if (!this.mapRef) return

    const urlTypes = this.mapRef.el.dataset.urlTypes.split(`,`)
    const params = {}

    query.forEach((q) => {
      if (urlTypes.includes(q.type)) {
        params[q.type] = params[q.type] || []
        params[q.type].push(q.value)
      }
    })

    let url = Object.entries(params)
      .map(([k, v]) => `${k}=${v.join(`,`)}`)
      .join(`&`)

    url = url ? `?${url}` : ``
    if (this.mapRef.el.id) url += `#${this.mapRef.el.id}`

    window.history.replaceState(null, null, url)
  },
})
